import { FONT_FAMILY } from '@/constants/constants'

export default {
  baseStyle: {
    fontFamily: FONT_FAMILY.default,
    flex: 1,
    p: '16px',
    width: '100%',
    borderColor: 'border',
    borderRadius: '4px',
    borderStyle: 'solid',
    borderWidth: '1px',
    minHeight: '100px',
    resize: 'none',
  },
  variants: {
    normal: {
      bg: 'bg',
      color: 'fg',
    },
  },
  defaultProps: {
    variant: 'normal',
  },
}
